import React from 'react'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {ViewOrder} from '../../models/OrderState'
import {selectViewOrder} from '../../redux/order/orderSlice'
import {OrderActionWrapper} from '../fulfillment/components/orderActions'
import {orderStatusType, orderType} from '../../models'
import CancelOrder from '../fulfillment/components/orderActions/components/CancelOrder'
import {useFeatureFlag} from 'app/features/context/FeatureFlagContext'

interface Props {}

export const OrderToolbar: React.FC<Props> = () => {
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)
  const {isPosOrderEditEnabled} = useFeatureFlag()

  if (order.status === orderStatusType.migration) {
    return <CancelOrder />
  }

  if (isPosOrderEditEnabled) {
    return (
      <div className='d-flex'>
        <OrderActionWrapper />
      </div>
    )
  }

  // Existing version logic for order status

  if (order.status !== orderStatusType.migration) {
    return (
      <div className='d-flex'>
        <OrderActionWrapper />
      </div>
    )
  }

  if (order.orderType === orderType.pos && order.isPosEdit) {
    return (
      <div className='d-flex'>
        <OrderActionWrapper />
      </div>
    )
  } else if (order.orderType === orderType.pos && order.isAdminEnabledPosCancel) {
    return (
      <div className='d-flex'>
        <CancelOrder />
      </div>
    )
  }

  return <div className='d-flex'></div>
}

export default OrderToolbar
